<template>
  <div class="activity-add">
    <iModal title="图片上传" v-model="showModal" width="612px" :mask-closable="false" @on-cancel="close()" :styles="{top: '150px'}">
      <div class="my-modal">
        <div class="my-modal-content">
          <Form :label-width="100">
            <FormItem ref="formInline" label="图片文件：">
              <div class="my-upload-list" v-for="(item, index) in uploadList" :key="'upload' + index" style="width: 100px;height: 100px;line-height:100px;">
                <template v-if="item.status === 'finished'">
                  <img :src="item.url" style="width:100%;height:100%;" />
                  <div class="my-upload-list-cover">
                    <Icon type="ios-trash-outline" @click.native.stop.prevent="handleRemoveByArr(item)"></Icon>
                  </div>
                </template>
                <template v-else>
                  <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                    <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                  </Spin>
                </template>
              </div>
              <Upload ref="upload" :show-upload-list="false" :default-file-list="defaultList" :on-success="handleSuccess" :format="['jpg','jpeg','png','gif']" :max-size="2048" :headers="formHeaders" :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" type="drag" :action="uploadUrl" multiple style="display: inline-block;width:100px;" v-show="uploadList && uploadList.length < 10">
                <div style="width: 100px;height:100px;padding-top:15px;color:rgb(133, 133, 133);">
                  <div style="font-size:25px;">
                    +
                    <p style="font-size:14px;">上传</p>
                  </div>
                </div>
              </Upload>
              <p class="upload-p" style="font-size:12px">(图片要求：2M以下的jpg,png,gif，建议尺寸750*500px)</p>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit()">保存</Button>
        <Button @click="close()">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    albumId: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      showModal: false,
      loading: false,
      uploadList: [],
      defaultList: []
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders"
    })
  },
  watch: {
    show (val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  methods: {
    ...mapActions({
      addMaterial: "materialModule/addMaterial"
    }),
    handleSuccess (res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleFormatError (file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg,png,gif格式的图片`);
    },
    handleMaxSize (file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    handleRemoveByArr (file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleBeforeUpload () {
      const limitNum = 10;
      const check = this.$refs.upload.fileList.length < limitNum;
      if (!check) {
        this.$Message.warning(`每次最多上传${limitNum}张图片`);
      }
      return check;
    },
    transfromImgList (arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    transfromSendImgList (list) {
      let sendArr = [];
      list.forEach((c, index) => {
        let formData = {
          CompId: this.company.id,
          AgentId: this.company.agentId,
          Name: c.name,
          Path: c.url,
          ShowIndex: 0
        };
        let id = this.$router.history.current.query.id;
        if (id) {
          formData.albumId = id;
        }
        console.log('相册id: ', this.albumId);
        sendArr.push(this.addMaterial(formData));
      });
      return Promise.all(sendArr);
    },
    async handleSubmit () {
      if (!(this.uploadList && this.uploadList.length)) {
        this.$Message.error(`请上传素材图片`);
        return;
      }
      this.loading = true;
      this.transfromSendImgList(this.uploadList)
        .then(v => {
          this.loading = false;
          this.$Message.success("添加成功");
          this.$emit("finish");
          this.close();
          this.$refs.upload.clearFiles();
        })
        .catch(e => {
          this.$Message.error("添加失败，请重新尝试");
          this.loading = false;
        });
    },
    close () {
      this.loading = false;
      this.showModal = false;
      this.loading = false;
      this.uploadList = [];
      this.defaultList = [];
      if (this.$refs["upload"]) this.$refs["upload"].clearFiles();
      this.$refs.upload.clearFiles();
      this.$emit("close");
    }
  },
  mounted () {
    this.uploadList = this.$refs.upload.fileList;
  }
};
</script>

<style lang="scss" scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
</style>